import { observable } from 'mobx';
import type { NonOrderItemPriceDetailResponseArgs } from './non_order_item_price_detail2';
import NonOrderItemPriceDetail, {
  convertNonOrderItemPriceDetailResponseToArgs
} from './non_order_item_price_detail2';

export type NonOrderItemPriceResponseArgs = {
  id: number;
  price: number;
  details?: NonOrderItemPriceDetailResponseArgs[];
};

export type NonOrderItemPriceArgs = {
  id: number;
  price: number;
  details: NonOrderItemPriceDetail[];
};

export const convertNonOrderItemPriceResponseToArgs = (response: NonOrderItemPriceResponseArgs) => {
  const args: NonOrderItemPriceArgs = {
    id: response.id,
    price: response.price,
    details:
      response.details?.map(
        detail => new NonOrderItemPriceDetail(convertNonOrderItemPriceDetailResponseToArgs(detail))
      ) || []
  };
  return args;
};

export default class NonOrderItemPrice {
  @observable id: number;
  @observable price: number;
  @observable details: NonOrderItemPriceDetail[];

  constructor(args: NonOrderItemPriceArgs) {
    this.id = args.id;
    this.price = args.price;
    this.details = args.details;
  }

  get totalPrice() {
    return this.price + (this.details.length > 0 ? this.details[0].price : 0);
  }

  get updateParams() {
    return {
      price: this.price,
      details: this.details.map(detail => detail.updateParams)
    };
  }
}
